import { OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { HelperService } from 'src/app/helper.service';
import { ImsService } from '../../ims.service';
import { ToasterService } from 'src/app/toaster.service';
import { Toaster, ToasterType } from 'src/app/shared/types';
import { GuestDetailsService } from '../guest-details.service';
import { resolveDomainValidationErrorMessage, resolveDomainValidationSuccessMessage, } from 'src/app/shared/domain-validation/domain-validation-messages';
var GuestAccountComponent = /** @class */ (function () {
    function GuestAccountComponent(imsService, toasterService, guestDetailsService) {
        this.imsService = imsService;
        this.toasterService = toasterService;
        this.guestDetailsService = guestDetailsService;
        this.newEmail = '';
        this.updatingEmail = false;
        this.errorMsg = '';
        this.corporateEmailChecked = false;
        this.corporateEmailDisabled = false;
        this.showEmailDialog = false;
        this.isEmailVerificationInProgress = false;
        this.domainType = '';
        this.domainTypeLookupLoading = false;
        this.domainTypeOptions = ['corporate', 'non_corporate'];
        this.walletBalance = null;
        this.walletBalanceLoading = false;
        this.walletBalanceError = false;
    }
    GuestAccountComponent.prototype.ngOnChanges = function (changes) {
        if (changes.data && changes.data.currentValue && changes.data.currentValue.dataFetched === false) {
            this.blankCard();
        }
        else if (changes.data && changes.data.currentValue) {
            this.data = changes.data.currentValue;
            this.constructCard();
            // Set checkbox state based on email only if not in verification process
            if (!this.isEmailVerificationInProgress) {
                var guest = this.data.profiles.find(function (profile) { return profile.type === 'guest'; });
                this.corporateEmailChecked = !!(guest && guest.email);
                this.corporateEmailDisabled = !!(guest && guest.email);
            }
            if (this.data && this.data.dataFetched === true && this.data.profiles) {
                var guestProfile = this.data.profiles.find(function (profile) { return profile.type === 'guest'; });
                if (guestProfile && guestProfile.id) {
                    this.fetchWalletBalance();
                }
            }
        }
        else {
            this.emptyCard();
        }
    };
    GuestAccountComponent.prototype.ngOnInit = function () { };
    GuestAccountComponent.prototype.blankCard = function () {
        this.info = {
            header: 'Hopr account',
            dataFetched: false,
            data: []
        };
    };
    GuestAccountComponent.prototype.emptyCard = function () {
        this.info = {
            header: 'Hopr account',
            dataFetched: false,
            data: null
        };
    };
    GuestAccountComponent.prototype.constructCard = function () {
        if (this.data) {
            var guest = this.data.profiles.find(function (profile) { return profile.type === 'guest'; });
            var cardData = [
                {
                    header: 'Current Status',
                    className: guest.status === "ACTIVE" ? 'green-badge' : 'red-badge',
                    value: guest.status === "ACTIVE" ? 'Active' : 'Inactive',
                    information: !guest.status
                }
            ];
            // Add wallet balance row if we've attempted to fetch it
            var walletBalanceCardData = HelperService.buildWalletBalanceCardData(this.walletBalance, this.walletBalanceLoading, this.walletBalanceError);
            if (walletBalanceCardData) {
                cardData.push(walletBalanceCardData);
            }
            // Add corporate email checkbox row
            cardData.push({ header: this.corporateEmailLabel, isCheckbox: true });
            // Add email updated by row
            if (guest) {
                cardData.push({
                    header: 'Email Updated By',
                    value: guest.updatedBy || 'N/A'
                });
            }
            this.info = {
                header: 'Hopr account',
                dataFetched: true,
                data: cardData,
                reload: true
            };
        }
    };
    GuestAccountComponent.prototype.formatDate = function (date) {
        return HelperService.dateString(date);
    };
    ;
    // --- Checkbox handler ---
    GuestAccountComponent.prototype.onCorporateEmailCheckboxChange = function (event) {
        if (event.target.checked && !this.corporateEmailDisabled) {
            this.isEmailVerificationInProgress = true;
            this.showEmailDialog = true;
            this.newEmail = '';
            this.resetDomainTypeSelection();
            this.errorMsg = '';
        }
    };
    GuestAccountComponent.prototype.resetDomainTypeSelection = function () {
        this.domainType = '';
        this.domainTypeLookupLoading = false;
    };
    GuestAccountComponent.prototype.canLookupEmail = function () {
        var trimmedEmail = this.newEmail ? this.newEmail.trim() : '';
        return trimmedEmail.indexOf('@') > 0;
    };
    GuestAccountComponent.prototype.lookupEmailDomain = function () {
        var _this = this;
        var trimmedEmail = this.newEmail ? this.newEmail.trim() : '';
        if (!trimmedEmail || trimmedEmail.indexOf('@') <= 0) {
            this.resetDomainTypeSelection();
            return;
        }
        this.domainTypeLookupLoading = true;
        this.imsService.lookupEmailDomain(trimmedEmail).subscribe({
            next: function (response) {
                _this.domainTypeLookupLoading = false;
                if (response && response.exists && response.domainType) {
                    _this.domainType = response.domainType;
                }
                else {
                    _this.domainType = '';
                }
            },
            error: function () {
                _this.domainTypeLookupLoading = false;
                _this.domainType = '';
            }
        });
    };
    // --- Dialog close handler ---
    GuestAccountComponent.prototype.closeEmailDialog = function () {
        this.showEmailDialog = false;
        this.isEmailVerificationInProgress = false;
        // Uncheck the box when cancelled
        this.corporateEmailChecked = false;
    };
    // --- Submit email from dialog ---
    GuestAccountComponent.prototype.submitEmail = function () {
        var _this = this;
        if (!this.data || !this.data.profiles)
            return;
        var guestProfile = this.data.profiles.find(function (profile) { return profile.type === 'guest'; });
        if (!guestProfile || !this.newEmail) {
            this.errorMsg = 'Please enter a valid email.';
            return;
        }
        if (!this.domainType) {
            this.errorMsg = 'Please select a domain type.';
            return;
        }
        this.updatingEmail = true;
        this.errorMsg = '';
        this.imsService.updateUserEmail(this.data.id, this.newEmail, ['guest'], this.domainType)
            .subscribe({
            next: function (res) {
                _this.showEmailDialog = false;
                _this.isEmailVerificationInProgress = false;
                _this.updatingEmail = false;
                _this.errorMsg = '';
                guestProfile.email = _this.newEmail;
                _this.constructCard();
                _this.corporateEmailChecked = true;
                _this.corporateEmailDisabled = true;
                // Show a success toaster
                var successCopy = resolveDomainValidationSuccessMessage(res) ||
                    'Corporate email verified successfully!';
                _this.toasterService.showToaster(new Toaster({
                    type: ToasterType.SUCCESS,
                    message: successCopy
                }));
                window.location.reload();
            },
            error: function (err) {
                _this.updatingEmail = false;
                _this.errorMsg = resolveDomainValidationErrorMessage(err);
                // Don't reset isEmailVerificationInProgress on error, let user try again or cancel
            }
        });
    };
    Object.defineProperty(GuestAccountComponent.prototype, "showVerifyEmailToggle", {
        get: function () {
            if (!this.info || !this.info.data)
                return false;
            var emailField = this.info.data.find(function (d) { return d.header === 'Email'; });
            return !emailField || !emailField.value || emailField.value === 'N/A';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GuestAccountComponent.prototype, "corporateEmailLabel", {
        get: function () {
            if (this.corporateEmailChecked && this.corporateEmailDisabled) {
                return 'Corporate Email (Verified)';
            }
            return 'Corporate Email (Not Verified)';
        },
        enumerable: true,
        configurable: true
    });
    GuestAccountComponent.prototype.fetchWalletBalance = function () {
        var _this = this;
        if (!this.data || !this.data.profiles) {
            return;
        }
        var guestProfile = this.data.profiles.find(function (profile) { return profile.type === 'guest'; });
        if (!guestProfile || !guestProfile.id) {
            return;
        }
        this.walletBalanceLoading = true;
        this.walletBalanceError = false;
        this.guestDetailsService.getGuestWalletBalance(guestProfile.id).subscribe({
            next: function (response) {
                _this.walletBalanceLoading = false;
                var balance = null;
                if (response && 'balance' in response) {
                    balance = response.balance;
                }
                if (balance !== null && balance !== undefined) {
                    var formattedBalance = parseFloat(balance).toFixed(2);
                    _this.walletBalance = formattedBalance;
                    _this.walletBalanceError = false;
                }
                else {
                    _this.walletBalance = 'Unable to fetch';
                    _this.walletBalanceError = true;
                }
                _this.constructCard();
            },
            error: function (err) {
                _this.walletBalanceLoading = false;
                _this.walletBalanceError = true;
                _this.walletBalance = 'Unable to fetch';
                _this.constructCard();
            }
        });
    };
    GuestAccountComponent.prototype.refreshWalletBalance = function () {
        this.walletBalanceError = false;
        this.fetchWalletBalance();
    };
    GuestAccountComponent.prototype.onRefresh = function () {
        this.refreshWalletBalance();
    };
    return GuestAccountComponent;
}());
export { GuestAccountComponent };
